const convertDateFormat = (dateStr) => {
  if (dateStr.length !== 8) {
    return "";
  }
  const day = dateStr.slice(0, 2);
  const month = dateStr.slice(2, 4);
  const year = dateStr.slice(4);

  return `${year}-${month}-${day}`;
};

export default convertDateFormat;
